// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"b3e56ba5","557":"5c734057","787":"e72a8928"}[chunkId] + ".chunk.js";
};